import {Breadcrumb} from '@/__generated__/__types__';
import {BreadcrumbInterface} from '@/_application/core/components/ui/breadcrumbs/breadcrumbs';

export const convertDataToBreadCrumbs = (data: Breadcrumb[]) => {
    if (!data?.length) {
        return [];
    }
    const sortedBreadCrumbs = data.sort((a, b) => +a.category_level! - +b?.category_level!);
    const result: BreadcrumbInterface[] = sortedBreadCrumbs?.map(item => {
        return {
            id: item.category_id?.toString() ?? (item.category_url_path as string),
            url: item.category_url_path ? `/${item?.category_url_path}.html` : '',
            title: item.category_name ?? '',
        };
    });
    return result;
};
